import { render, staticRenderFns } from "./counterpartiesUser.vue?vue&type=template&id=710d9c92&scoped=true"
import script from "./counterpartiesUser.vue?vue&type=script&lang=js"
export * from "./counterpartiesUser.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesUser.vue?vue&type=style&index=0&id=710d9c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d9c92",
  null
  
)

export default component.exports